import localforage from 'localforage';

const setupLocalForage = localforage.createInstance({
  name: 'GGC.Admin',
});

export default setupLocalForage;